import api from '../../services/api';

export async function getStandard(factoryId) {

    let response = await api.get(`/Standard/odata?$filter=status+eq+'Official'+and+structure/factoryId+eq+${factoryId}&$select=standardType,structureId,updatedAt`);

    if (response.status === 200)
        return response.data.value;
    else
        return [];

}

export async function getTraining(factoryId) {

    let response = await api.get(`/traininguser/odata?$filter=standard/structure/factoryId+eq+${factoryId}+and+standard/status+eq+'Official'+and+standardId+ne+null+&$select=status,updatedAt&$expand=standard($select=structureId,standardType)`);

    if (response.status === 200)
        return response.data.value;
    else
        return [];

}

export async function getStructure(factoryId) {

    let response = await api.get(`/structure/odata?$filter=factoryId+eq+${factoryId}`);

    if (response.status === 200)
        return response.data.value;
    else
        return [];

}